// services/cookieUtils.js

export default {
  /**
   * Set a cookie
   * @param {string} name - Cookie name
   * @param {*} value - Cookie value (will be JSON stringified)
   * @param {number} days - Days until expiration
   */
  setCookie(name, value, days = 365) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + JSON.stringify(value) + ";" + expires + ";path=/";
  },

  /**
   * Get a cookie value
   * @param {string} name - Cookie name
   * @returns {*} Parsed cookie value or null
   */
  getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) {
        try {
          return JSON.parse(c.substring(nameEQ.length, c.length));
        } catch (e) {
          return c.substring(nameEQ.length, c.length);
        }
      }
    }
    return null;
  },

  /**
   * Delete a cookie
   * @param {string} name - Cookie name
   */
  deleteCookie(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  },

  /**
   * Track category preference
   * @param {string|number} categoryId - Category ID to track
   * @param {number} maxCategories - Maximum categories to track
   */
  trackCategoryPreference(categoryId, maxCategories = 10) {
    let preferences = this.getCookie('user_category_preferences') || {};
    
    // Initialize or increment count
    if (preferences[categoryId]) {
      preferences[categoryId]++;
    } else {
      preferences[categoryId] = 1;
    }

    // Sort by count and keep only top N categories
    const sorted = Object.entries(preferences)
      .sort((a, b) => b[1] - a[1])
      .slice(0, maxCategories);
    
    preferences = Object.fromEntries(sorted);
    
    this.setCookie('user_category_preferences', preferences);
  },

  /**
   * Get top preferred categories
   * @param {number} limit - Number of categories to return
   * @returns {Array} Array of category IDs sorted by preference
   */
  getTopCategories(limit = 5) {
    const preferences = this.getCookie('user_category_preferences') || {};
    return Object.entries(preferences)
      .sort((a, b) => b[1] - a[1])
      .slice(0, limit)
      .map(([id]) => id);
  },

  /**
   * Track sales type preference
   * @param {string} salesType - Sales type to track
   */
  trackSalesTypePreference(salesType) {
    let preferences = this.getCookie('user_salestype_preferences') || {};
    
    if (preferences[salesType]) {
      preferences[salesType]++;
    } else {
      preferences[salesType] = 1;
    }

    this.setCookie('user_salestype_preferences', preferences);
  },

  /**
   * Get preferred sales types
   * @returns {Array} Array of sales types sorted by preference
   */
  getPreferredSalesTypes() {
    const preferences = this.getCookie('user_salestype_preferences') || {};
    return Object.entries(preferences)
      .sort((a, b) => b[1] - a[1])
      .map(([type]) => type);
  }
};